<template lang="pug">
  model-data-table( 
    no-data-text="Sin cartolas de banco."
    no-search
    ref="table" 
    v-bind="tableProps" 
    )
    v-btn( 
      color="success"
      flat 
      icon 
      slot="actions" 
      slot-scope="props" 
      v-if="!props.item.matched"
      @click="submitGenerate( props )" 
      )
      v-icon payment
</template>

<script>
  //
  import { mapActions, mapState } from "vuex"
  import { ModelDataTable } from "@/components/reusable_components/next"
  import AccountingBankCardModel from "@/models/Accounting/AccAccountingBankCard"
  import AccAccountingBankCardChileService from "@/services/api/accounting/AccAccountingBankCardChile"
  import AccountingBankCardFilters from "@/views/Accounting/AccAccountingBankCard/partials/AccountingBankCardFilters"
  import AccountingBankCardHeaders from "@/views/Accounting/AccAccountingBankCard/partials/AccountingBankCardHeaders"
  //
  export default {
    name: "accounting-bank-card-list",
    components: {
      ModelDataTable,
    },
    computed: {

      /**
       * 
       */
      tableProps () {
        return {
          filters: AccountingBankCardFilters,
          headers: AccountingBankCardHeaders,
          noActions: ! this.$can( "CREATE_INVOICE_PAYMENT_VIA_BANK_CARD" ),
          service: AccAccountingBankCardChileService,
        }
      },

      /**
       * 
       */
      toolbarItems () {
        return [
          {
            text: "agregar cartola de pago",
            icon: "add_circle",
            action: this.submitCreate,
          }
        ]
      },
    },
    methods: {

      //
      ...mapActions("MenuesModule", [
        "setItemsTopBar",
        "setTitleTopBar",
      ]),
      
      /**
       * 
       */
      submitCreate() {
        this.$router.push({ name: "bank-card-create" })
      },
      
      /**
       * 
       */
      submitGenerate ( event ) {
        this.$router.push({ name: "bank-card-generate", params: { id: event.item.id } })
      },
    },
    mounted () {
      this.setItemsTopBar( this.toolbarItems )
      this.setTitleTopBar( "Cartolas de pago" )
    },
  }
</script>
